import { CellProperties } from 'handsontable/settings';
import { CellData } from '../../../../../common/table/TableTypes';
import { set } from 'lodash';

// TODO - Should this be changed to select between rows and columns?
/**
 * Gets the cell data from the provided cell metas up to the specified row and column limits.
 */
export const getTableCellData = (cellMetas: CellProperties[], toRow: number, toCol: number): CellData[][] => {
    const data: CellData[][] = [];

    cellMetas.forEach((cellMeta) => {
        const { row, col, cellData } = cellMeta || {};
        if (cellData && row < toRow && col < toCol) set(data, [row, col], cellData);
    });

    return data;
};
